"use client";

import { AlertTriangle, Loader2, RotateCw } from "lucide-react";

interface ServiceUnavailableBannerProps {
  onRetry: () => void;
  checking?: boolean;
  className?: string;
}

/** Shown while a blocking Designer dependency is down (PLA2-945). */
export function ServiceUnavailableBanner({
  onRetry,
  checking = false,
  className = "",
}: ServiceUnavailableBannerProps) {
  return (
    <div
      role="alert"
      className={`flex items-start gap-3 rounded-xl border border-amber-400 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-500/60 dark:bg-amber-900/20 dark:text-amber-100 ${className}`}
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-500" />
      <div className="min-w-0 flex-1 space-y-1">
        <p className="font-bold">The designer is temporarily unavailable.</p>
        <p>
          We&apos;re having trouble reaching our design service, so uploading
          photos and creating designs is paused for now. Your work is safe.
          Please check back shortly; this page will recover on its own.
        </p>
      </div>
      <button
        type="button"
        onClick={onRetry}
        disabled={checking}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border-2 border-amber-500 bg-white px-3 py-1.5 text-sm font-bold text-amber-900 transition-colors hover:bg-amber-100 disabled:opacity-60 dark:bg-amber-950 dark:text-amber-100 dark:hover:bg-amber-900"
      >
        {checking ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <RotateCw className="h-4 w-4" />
        )}
        Try again
      </button>
    </div>
  );
}
